import styled from 'styled-components'
import cross from '../../assets/addStockModal/pages/cross.svg'
import check from '../../assets/addStockModal/pages/check.svg'
import arrowDown from '../../assets/certificates/AddParameter/arrow-down.svg'

export const Container = styled.div`
    position: absolute;
    width: 42.5rem;
    height: 38.5rem;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;
    padding: 20px
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;

    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const HeaderText = styled.h2`
    font-family: 'Inter', sans-serif;
    font-size: 1.4vw;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 0;
    color: #303030;
`

export const InfoProduction = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 3.5vh;
`

export const StatusProduction = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
`

export const TimeProduction = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
`

export const InfoText = styled.span`
    font-family: Inter, sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: #303030;
`

export const NameInfo = styled.span`
    font-family: Inter, sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #303030;
`

export const Separator = styled.hr`
  border: none;
  height: 1px;
  background-color: #EBEBEB;
  margin: 15px 0;
`

export const Labor = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
`

export const Employees = styled.div`
    display: grid;
    margin-top: 4.5vh;
`

export const Select = styled.select`
    width: 19rem;
    height: 2.5rem;
    border-radius: 20px;
    background-color: #EBEBEB;
    margin-top: 1rem;
`

export const ItemsTable = styled.div`
    margin-top: 1.5rem;
`

export const TableTitle = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 0.5rem;
`

export const TableText = styled.span`
    font-family: Inter, sans-serif;
    font-size: 12px;
    color: #696969;
    font-weight: 400;
`

export const TableInfo = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    background-color: #F4F4F4;
    border-bottom: 1px solid #C4C4C4;
    height: 2.5rem;
    align-items: center;
    padding: 0.5rem;
    border-radius: 8px 8px 0 0;
`

export const TableInfoText = styled.span`
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #696969;
`

export const ActionsDiv = styled.div`
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 5rem 0;
    gap: 16px;
`

export const CloseButton = styled.button`
    font-family: Inter, sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: #0090D3;
    border: none;
    background-color: transparent;
    cursor: pointer;
`

export const HalfButton = styled.button`
    width: 8rem;
    height: 2.5rem;
    border-radius: 20px;
    border: 1px solid #0090D3;
    background-color: #FFFFFF;
    color: #0090D3;
    font-family: Inter, sans-serif;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
`

export const PlayButton = styled.button`
    width: 11rem;
    height: 2.5rem;
    border-radius: 20px;
    border: none;
    background-color: #0090D3;
    color: #FFFFFF;
    font-family: Inter, sans-serif;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
`